// extracted by mini-css-extract-plugin
export var actionButton = "_c6-5";
export var actionButtonActive = "_c6-6";
export var content = "_c6-3";
export var header = "_c6-4";
export var list = "_c6-7";
export var settingsContent = "_c6-a";
export var settingsPanel = "_c6-b";
export var settingsRow = "_c6-c";
export var state = "_c6-9";
export var triggerBadge = "_c6-2";
export var triggerButton = "_c6-1";
export var triggerShell = "_c6-0";
export var unreadDot = "_c6-8";